import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({ title, paragraph, image, backgroundColor, isCentered }) => {
  return (
    <div
      className={`project-card ${isCentered ? 'centered' : ''}`}
      style={{backgroundColor }}
    >
      <div className="project-card-content">
        <h3>{title}</h3>
        <p>{paragraph}</p>
       
      </div>
      <img src={image} alt={title} className="project-card-image" />
    </div>
  );
};

export default ProjectCard;
